import { heroStats } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section id="top" aria-labelledby="hero-title" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=a%20cinematic%20editorial%20abstract%20stage%20with%20a%20single%20warm%20spotlight%20beam%20cutting%20through%20deep%20charcoal%20darkness%2C%20floating%20dust%20particles%2C%20subtle%20vermilion%20and%20amber%20glow%2C%20moody%20premium%20magazine%20cover%20atmosphere%2C%20dramatic%20negative%20space%2C%20high%20detail&width=1600&height=1000&seq=heibaoxianchang-hero-01&orientation=landscape"
          alt="聚光灯下的事件现场氛围图"
          className="h-full w-full object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/92 via-primary-950/70 to-primary-950/35" />
      </div>

      <div className="relative mx-auto flex min-h-[520px] w-full max-w-[1400px] flex-col justify-center px-4 py-16 md:min-h-[620px] md:px-6 md:py-20">
        <div className="max-w-3xl">
          <p className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-primary-950/40 px-4 py-1.5 text-xs tracking-[0.2em] text-accent-300">
            <span className="flex h-2 w-2 items-center justify-center">
              <span className="h-2 w-2 animate-pulse rounded-full bg-accent-400" />
            </span>
            第一弹 · 独家速递
          </p>

          <h1
            id="hero-title"
            className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 sm:text-4xl md:text-5xl lg:text-6xl"
          >
            网红黑曝现场
            <span className="mt-3 block text-accent-300">直击第一弹,速递不缺席</span>
          </h1>

          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            这里聚合网红黑曝首发、独家和速递消息:谁在发酵、进展到哪一步、哪些还是待核实的疑点。按时间线梳理,不吃二手瓜,不错过任何一个关键细节。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#latest"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-line text-base" aria-hidden="true" />
              查看最新爆料
            </a>
            <a
              href="#live"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 px-6 py-3 text-sm text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-live-line text-base" aria-hidden="true" />
              进入实时速递
            </a>
          </div>
        </div>

        <ul className="mt-12 grid grid-cols-2 gap-x-6 gap-y-6 border-t border-background-50/15 pt-8 md:mt-14 md:grid-cols-4">
          {heroStats.map((stat) => (
            <li key={stat.label}>
              <p className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
                {stat.value}
                <span className="ml-1 text-sm font-normal text-accent-300">{stat.suffix}</span>
              </p>
              <p className="mt-2 text-xs text-background-300 md:text-sm">{stat.label}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}